module.exports = __webpack_public_path__ + "static/media/user-icon.57620f06.png";